import { withInstall } from '@tav-ui/utils/with-install'
import ButtonPopconfirm from './src/button-popconfirm.vue'
const TaButtonPopconfirm = withInstall(ButtonPopconfirm)
export { TaButtonPopconfirm }
export default TaButtonPopconfirm
export * from './src/types'
